import { get } from '@shared/adapters/lodash'
import type { WalletStatus } from '../types/walletTypes'

export const parseWalletStatus = (resp: unknown): WalletStatus => ({
  walletId: get(resp, 'data.walletId') ?? null,
  trustlineStatus: get(resp, 'data.trustlineStatus') ?? null,
  walletStatus: get(resp, 'data.walletStatus') ?? null,
  isReady: Boolean(get(resp, 'data.isReady')),
})
